import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ForeignerPersonalContext } from "./ForeignerPersonalContext";

export const ForeignerPersonalHistory = () => {
    const toast = useRef(null);
    const dt1 = useRef(null);
    const { t, i18n } = useTranslation(["foreigner-personal", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const foreignerPersonalContext = useContext(ForeignerPersonalContext);
    const { foreignerPersonalHistories, setForeignerPersonalHistories, setForeignerPersonalHistoryDialog, foreignerPersonalHistoryDialog } = foreignerPersonalContext;

    const [title, setTitle] = useState(t("foreigner-personal.infohistorydetail"));

    const hideDialog = () => {
        setForeignerPersonalHistoryDialog(false);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "contents" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };
    return (
        <Dialog visible={foreignerPersonalHistoryDialog} style={{ width: "70%" }} header={title} modal className="p-fluid text-center" onHide={hideDialog}>
            <div className="formgrid">
                <div className="grid mt-2">
                    <div className="col-12">
                        <BlockDetail title={t("foreigner-personal.historyChangeInfo")}>
                            <DataTable
                                ref={dt1}
                                value={foreignerPersonalHistories}
                                dataKey="stt"
                                className="datatable-responsive p-datatable-sm"
                                showGridlines
                                emptyMessage="Không có dữ liệu"
                                rows={10}
                                first={0}
                                paginator
                                paginatorClassName="justify-content-start"
                                paginatorTemplate={paginatorTemplate}
                                totalRecords={foreignerPersonalHistories.length}
                            >
                                <Column field="stt" header={t("stt", { ns: "common" })} />
                                <Column field="maSoDdcn" header={t("foreigner-personal.maSoDdcn")} />
                                <Column field="field" header={t("foreigner-personal.field")} />
                                <Column field="valueBefore" header={t("foreigner-personal.valueBefore")} />
                                <Column field="valueAfter" header={t("foreigner-personal.valueAfter")} />
                                <Column field="ngayThayDoi" header={t("foreigner-personal.ngayThayDoi")} />
                                <Column field="nguonCapNhat" header={t("foreigner-personal.nguonCapNhat")} />
                                <Column field="nguoiThayDoi" header={t("foreigner-personal.nguoiThayDoi")} />
                            </DataTable>
                        </BlockDetail>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col-12">
                    <Button
                        style={{
                            width: "max-content",
                        }}
                        label={t("close", { ns: "common" })}
                        icon="pi pi-times"
                        onClick={hideDialog}
                    />
                </div>
            </div>
        </Dialog>
    );
};
